import {
  LOGIN,
  LOGOUT,
  SHOW_APP_BAR,
  IS_LOADING,
  SET_ROLE,
  SET_GENERAL_DATA,
  SET_ALERT_DIALOG_CONTENT
} from "../types";
import api from "../../utils/api";

export const authActions = (props) => {
  return {
    login: (data, history) => {
      const payload = {
        username: data.username,
        password: data.password,
      };
      props.dispatch({ type: IS_LOADING, data: true });
      api.qmsService
          .post(`/services/qms/login`, payload)
          .then(res => {
            sessionStorage.setItem("userToken", res.data.token);
            sessionStorage.setItem("role", res.data.role);
            props.dispatch({ type: SHOW_APP_BAR, data: true });
            props.dispatch({ type: IS_LOADING, data: false });
            props.dispatch({ type: SET_ROLE, role: res.data.role });
            history.push("/student/register")
            // if (res.data.result === "Application update successful") {
              // props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({ type: SET_GENERAL_DATA, data: { contractPreview: res.data.contractPreview} });
            // }
          })
          .catch(error => {
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Oops",
                  content: error.data.error.message
              });
          });
      props.dispatch({ type: LOGIN, data })
    },
    logout: (data) => {
      props.dispatch({ type: SET_GENERAL_DATA, data : {
              showNavDrawer: false,
              showAppBar: false
          } })
    },
  }
};